import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ControlContainer, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { SelectBox, TimeApiService, UsedSgkz011aService, UsedSzza001aService } from 'cbc-shared-lib';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  ResponseCommon, Sgkz011aResponseUserOrganizationDto, CodeConversionMstDto,
  Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto, Sgkb702aResInclusiveCtrInfoDto,
  Sgkb991aRequest, Sgkb991aResponse, Sgkb991aResBushoInfoDto,
  Sgkb992aRequest, Sgkb992aResStaffInfoDto, Sgkb992aResponse,
} from 'sg-api';
import { SgkbConstains } from '../../../../../sg-kb-shared/sg-kb-constans';
import { UsedSgkb991aService } from '../../services/used-sgkb991a.service';
import { UsedSgkb992aService } from '../../services/used-sgkb992a.service';

@Component({
  selector: 'app-sgkb708d-ctrinfo',
  templateUrl: './sgkb708d-ctrinfo.component.html',
  styleUrl: './sgkb708d-ctrinfo.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class Sgkb708dCtrinfoComponent implements OnInit, OnDestroy {

  /** 遷移元ステータス */
  @Input() mode: string;
  /** 包括契約検索APIレスポンス */
  @Input() incCtrSearchresult: Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto;
  /** コード一覧 */
  @Input() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
  /** 契約担当部署のセレクトボックスデータ */
  @Input() keiyakuTantouBushoList: SelectBox[] = [];

  @Output() selectedType = new EventEmitter<string>();

  /** 親コンポーネント保持領域 */
  parentForm: UntypedFormGroup | null = null;;
  /** 包括契約情報格納FormGroup*/
  registContractInfoForm: UntypedFormGroup;

  private onDestroy$ = new Subject();

  /** 包括お客さま情報 */
  /** 包括お客さま番号 */
  houkatsuOkyakusamaNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true });
  /** 包括お客さま名 */
  houkatsuOkyakusamaName: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 郵便番号 */
  yubinNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 都道府県 */
  todoufuken: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 都道府県hidden */
  todoufukenCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 行政市区 */
  gyouseishiku: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 行政市区hidden */
  gyouseishikuCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 行政町名 */
  gyouseichomei: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 行政町名hidden */
  gyouseichomeiCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 丁目 */
  chomeCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 番地・号 */
  banchi: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 建物名 */
  tatemonoName: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 部屋番号 */
  heyaNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約担当部署 */
  keiyakuTantouBushoCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約担当者リスト */
  keiyakuTantoushaCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約担当者テキスト */
  keiyakuTantousha: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括お客さま担当部署 */
  houkatsuOkyakusamaTantoBusho: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括お客さま担当者 */
  houkatsuOkyakusamaTantosha: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括お客さま電話番号 */
  houkatsuOkyakusamaTELNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });

  /** 包括契約情報 */
  /** 契約開始日 */
  keiyakuKaishiYMD: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括契約適用年数 */
  houkatsuTekiyouNensu: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約変更適用開始日 */
  keiyakuHenkouTekiyouKaishiYMD: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約満了日 */
  keiyakuManryouYMD: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 解約日 */
  kaiyakuYMD: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括割引・割増方法 */
  houkatsuHouhouCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** メモ */
  memo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括契約履歴番号 */
  inclusioncontractRrkno: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括契約年度内通番号 */
  inclusioncontractYearnaiSrno: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括契約状態コード */
  inclusioncontractStcode: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 登録申請状況コード */
  inclusioncontractRegistrationapplicationJokycd: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 解約申請状況コード */
  inclusioncontractBreakereqestJokycd: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約登録種別コード */
  inclusioncontractRegistrationapplicationClscode: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 包括契約登録操作コード */
  inclusioncontractRegOperationcode: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 更新通番号 */
  updateSrno: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 会社グループコード */
  comgrpcd: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });

  /** 契約担当者リスト表示フラグ */
  keiyakuTantouflg: boolean;
  /** 包括お客さま番号表示フラグ */
  houkatsuOkyakusamaNoDispFlg: boolean;
  /** 検索ボタン非活性フラグ */
  zyuushoSearchDisabledFlg: boolean;

  /** ユーザ組織情報 */
  userOrganizationInfo: Sgkz011aResponseUserOrganizationDto = {
    sosikiId: '',
    sosikiName: '',
    comgrpcd: '',
    comCode: '',
    topSosikiId: '',
    areaCd: '',
    kyotenHyojiFlg: '',
    cmpnyName: '',
  };
  /** ユーザー名 */
  usrKanjiname: string = "";
  /** ユーザーID */
  usrId: string = "";
  // 部署コード
  bushoCode: string = "";

  /** 部署情報検索結果 */
  sgkb991aResponse: Sgkb991aResponse;
  /** responseCommon(SGKB991A) */
  sgkb991aResponseCommon: ResponseCommon;
  /** 部署情報リスト */
  bushoInfoList: Array<Sgkb991aResBushoInfoDto>;

  /** 社員情報検索結果 */
  sgkb992aResponse: Sgkb992aResponse;
  /** responseCommon(SGKB992A) */
  sgkb992aResponseCommon: ResponseCommon;
  /** 社員情報リスト */
  staffInfoList: Array<Sgkb992aResStaffInfoDto>;

  /** 画面項目の編集変数 */
  /** コード変換マスタから受け取る割引・割増種類コードのリスト */
  preHoukatsuHouhouList: SelectBox[] = [];
  /** 割引・割増種類のセレクトボックスデータ */
  houkatsuHouhouList: SelectBox[] = [];
  /** 丁目のセレクトボックスデータ */
  chomeList: SelectBox[] = [];

  /** 契約担当者のセレクトボックスデータ */
  keiyakuTantoushaList: SelectBox[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private parent: FormGroupDirective,
    private timeApiService: TimeApiService,
    private usedSgkz011aService: UsedSgkz011aService,
    private usedSzza001aService: UsedSzza001aService,
    private cdr: ChangeDetectorRef,
    private usedSgkb991aService: UsedSgkb991aService,
    private usedSgkb992aService: UsedSgkb992aService
  ) { }

  /**
   * 購読を停止する処理
   * @memberof Sgkb708dCtrinfoComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.registContractInfoForm.clearValidators();
    this.registContractInfoForm.updateValueAndValidity();
    this.registContractInfoForm.removeControl('registContractInfoForm');
  }

  /**
   * 初期表示処理
   * @memberof Sgkb708dCtrinfoComponent
   */
  ngOnInit(): void {
    this.registContractInfoForm = this.fb.group({
      houkatsuOkyakusamaNo: this.houkatsuOkyakusamaNo,
      houkatsuOkyakusamaName: this.houkatsuOkyakusamaName,
      yubinNo: this.yubinNo,
      todoufuken: this.todoufuken,
      todoufukenCategory: this.todoufukenCategory,
      gyouseishiku: this.gyouseishiku,
      gyouseishikuCategory: this.gyouseishikuCategory,
      gyouseichomei: this.gyouseichomei,
      gyouseichomeiCategory: this.gyouseichomeiCategory,
      chomeCategory: this.chomeCategory,
      banchi: this.banchi,
      tatemonoName: this.tatemonoName,
      heyaNo: this.heyaNo,
      keiyakuTantouBushoCategory: this.keiyakuTantouBushoCategory,
      keiyakuTantoushaCategory: this.keiyakuTantoushaCategory,
      keiyakuTantousha: this.keiyakuTantousha,
      houkatsuOkyakusamaTantoBusho: this.houkatsuOkyakusamaTantoBusho,
      houkatsuOkyakusamaTantosha: this.houkatsuOkyakusamaTantosha,
      houkatsuOkyakusamaTELNo: this.houkatsuOkyakusamaTELNo,
      keiyakuKaishiYMD: this.keiyakuKaishiYMD,
      houkatsuTekiyouNensu: this.houkatsuTekiyouNensu,
      keiyakuHenkouTekiyouKaishiYMD: this.keiyakuHenkouTekiyouKaishiYMD,
      keiyakuManryouYMD: this.keiyakuManryouYMD,
      kaiyakuYMD: this.kaiyakuYMD,
      houkatsuHouhouCategory: this.houkatsuHouhouCategory,
      memo: this.memo,
      inclusioncontractRrkno: this.inclusioncontractRrkno,
      inclusioncontractYearnaiSrno: this.inclusioncontractYearnaiSrno,
      inclusioncontractStcode: this.inclusioncontractStcode,
      inclusioncontractRegistrationapplicationJokycd: this.inclusioncontractRegistrationapplicationJokycd,
      inclusioncontractBreakereqestJokycd: this.inclusioncontractBreakereqestJokycd,
      inclusioncontractRegistrationapplicationClscode: this.inclusioncontractRegistrationapplicationClscode,
      inclusioncontractRegOperationcode: this.inclusioncontractRegOperationcode,
      updateSrno: this.updateSrno,
      comgrpcd: this.comgrpcd,
    });
    this.parentForm = this.parent.form;
    this.parentForm.addControl('registContractInfoForm', this.registContractInfoForm);

    // 画面項目を初期化
    this.setInitDisp();
    // 割引・割増種類のセレクトボックスデータ生成
    this.preHoukatsuHouhouList = this.getSelectBoxFromCodeConversionMst("S000651");
    this.houkatsuHouhouList = this.setSelectBoxData(this.preHoukatsuHouhouList);

    this.usedSgkz011aService.updateUserInfo();
    // 組織情報取得
    this.usedSgkz011aService.userOrganizationInfo
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(userOrganizationInfo => {
        this.userOrganizationInfo = userOrganizationInfo;
      });

    // ユーザ名取得
    this.usedSgkz011aService.userKanjiname
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(usrKanjiname => {
        this.usrKanjiname = usrKanjiname;
      });

    // ユーザID取得
    this.usedSgkz011aService.userId
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(userId => {
        this.usrId = userId;
        this.configureFormControls();
        // 変更検出を行い、ビューとデータの整合性を確保
        this.cdr.detectChanges();
      });

    // 部署情報取得レスポンスを取得
    this.usedSgkb991aService.searchContractor(this.setSgkb991aRequest())
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb991aResponseCommon = response.responseCommon;
        this.bushoInfoList = response.bushoInfoList;
        // 契約担当部署リストの件数が0件の場合は部署情報取得レスポンスを契約担当部署リストに設定する
        if (this.keiyakuTantouBushoList.length == 0) {
          /** 契約担当部署リスト情報 */
          this.bushoInfoList.forEach(data => {
            const select: SelectBox = { value: data.bushoCode, viewValue: data.departmentName };
            this.keiyakuTantouBushoList.push(select);
          })
        }
      })

    // 社員情報取得レスポンスを取得
    this.bushoCode = this.userOrganizationInfo.sosikiId;
    this.usedSgkb992aService.searchContractor(this.setSgkb992aRequest())
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb992aResponseCommon = response.responseCommon;
        this.staffInfoList = response.staffInfoList;
        //  契約担当者リストの件数が0件の場合は 社員情報取得レスポンスを契約担当者リストに設定する
        if (this.keiyakuTantoushaList.length == 0) {
          /** 契約担当者リスト情報 */
          this.staffInfoList.forEach(data => {
            const select: SelectBox = { value: data.staffCode, viewValue: data.staffName };
            this.keiyakuTantoushaList.push(select);
          })
        }
      })

  }

  /**
   * セレクトボックスの自動生成
   * @memberof Sgkb708dCtrinfoComponent
   */
  getSelectBoxFromCodeConversionMst(codeId: string): SelectBox[] {
    let SelectBoxList: SelectBox[] = [];
    let codeList: CodeConversionMstDto[] = [];
    if (this.codeConversionMstMap.has(codeId)) {
      codeList = this.codeConversionMstMap.get(codeId);
      if (codeList) {
        codeList.forEach(data => {
          const select: SelectBox = { value: data.userCode, viewValue: data.hyojiCont };
          SelectBoxList.push(select);
        })
      }
    }
    return SelectBoxList;
  }

  /** 
   * セレクトボックスの初期選択値を設定
   * @memberof Sgkb708dCtrinfoComponent
   */
  setSelectBoxData(codeList: Array<SelectBox>): SelectBox[] {

    let selectBox: SelectBox[]

    selectBox = codeList.map(data => ({
      value: data.value,
      viewValue: data.viewValue,
    }))
    return selectBox;
  }

  /**
   * フォーム制御処理（初期値の設定）
   * @memberof Sgkb708dCtrinfoComponent
   */
  configureFormControls(): void {

    // 遷移パラメータが 登録 の場合
    if (this.mode === 'create') {
      // 契約担当部署（ログイン情報から取得）
      this.registContractInfoForm.controls['keiyakuTantouBushoCategory']
        .setValue(this.userOrganizationInfo.sosikiId);
      // 契約担当者リスト（ログイン情報から取得）
      this.registContractInfoForm.controls['keiyakuTantoushaCategory']
        .setValue(this.usrId);
      // 契約担当者テキスト（ログイン情報から取得）
      this.registContractInfoForm.controls['keiyakuTantousha']
        .setValue(this.usrKanjiname);
      // 会社グループコード
      this.registContractInfoForm.controls['comgrpcd']
        .setValue(this.userOrganizationInfo.comgrpcd);

      // 包括契約登録操作コード 2（登録）
      this.registContractInfoForm.controls['inclusioncontractRegOperationcode'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.REGIST);
      // 登録申請状況コード（申請中)
      this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationJokycd'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_APLY_CD.APPLY);
      // 契約登録種別コード（新規登録)
      this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationClscode'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_REGIST_CLY_CD.NEW_CNTRCT);
      // 包括お客さま番号（非表示）
      this.houkatsuOkyakusamaNoDispFlg = false;
      // 契約変更適用開始日
      this.registContractInfoForm.controls['keiyakuHenkouTekiyouKaishiYMD'].disable();
      // 登録、期中変更、契約更改の共通項目設定
      this.setRegistDisp();

      // 契約開始日
      this.keiyakuKaishiYMD.setValidators(Validators.required);
      // 包括契約適用年数
      this.houkatsuTekiyouNensu.setValidators(Validators.required);
      // 契約満了日
      this.keiyakuManryouYMD.setValidators(Validators.required);
      // 割引・割増種類
      this.houkatsuHouhouCategory.setValidators(Validators.required);
      // 都道府県
      this.registContractInfoForm.controls['todoufuken'].disable();
      // 行政市区
      this.registContractInfoForm.controls['gyouseishiku'].disable();
      // 行政町名
      this.registContractInfoForm.controls['gyouseichomei'].disable();
      // 登録、期中変更、契約更改の共通必須項目設定
      this.setRequired();
      return;
    }

    if (!this.incCtrSearchresult?.inclusiveCtrInfoList?.length) {
      return;
    }

    // 親コンポーネントで取得した包括契約検索APIレスポンスの業務情報を設定
    const incCtrInfoDto: Sgkb702aResInclusiveCtrInfoDto =
      this.incCtrSearchresult.inclusiveCtrInfoList[0];

    // 包括お客さま番号
    this.registContractInfoForm.controls['houkatsuOkyakusamaNo']
      .setValue(incCtrInfoDto.inclusioncontractVisitornumber);
    // 包括お客さま名
    this.registContractInfoForm.controls['houkatsuOkyakusamaName']
      .setValue(incCtrInfoDto.inclusioncontractVisitormei);

    // 郵便番号
    const postno1: string = incCtrInfoDto.postno.slice(0, 3);
    const postno2: string = incCtrInfoDto.postno.slice(3, 7);
    this.registContractInfoForm.controls['yubinNo']
      .setValue(postno1 + "-" + postno2);
    // 住所情報取得
    this.onClickZyuushoSearch(incCtrInfoDto.postno, incCtrInfoDto.addressCode);
    // 都道府県
    this.registContractInfoForm.controls['todoufuken'].disable();
    // 行政市区
    this.registContractInfoForm.controls['gyouseishiku'].disable();
    // 行政町名
    this.registContractInfoForm.controls['gyouseichomei'].disable();

    // 番地・号
    this.registContractInfoForm.controls['banchi']
      .setValue(incCtrInfoDto.chomeanameIkaKanjitext);
    // 建物名
    this.registContractInfoForm.controls['tatemonoName']
      .setValue(incCtrInfoDto.supadrKanjiAname1);
    // 部屋番号
    this.registContractInfoForm.controls['heyaNo']
      .setValue(incCtrInfoDto.yagouAname);

    // 遷移パラメータが 登録以外 の場合
    if (this.mode !== 'create') {
      // 契約担当部署（包括契約検索APIから取得）
      this.registContractInfoForm.controls['keiyakuTantouBushoCategory']
        .setValue(incCtrInfoDto.tantoSosikiId);
    }

    // 遷移パラメータが 期中変更、契約更改 のいずれかの場合
    if (this.mode === 'midterm_change'
      || this.mode === 'renewal') {
      // 契約担当者リスト（包括契約検索APIから取得）
      this.registContractInfoForm.controls['keiyakuTantoushaCategory']
        .setValue(incCtrInfoDto.tantoStaffNo);
    }
    // 契約担当者テキスト（包括契約検索APIから取得）
    this.registContractInfoForm.controls['keiyakuTantousha']
      .setValue(incCtrInfoDto.contractdateconclusionStaffname);

    // 包括お客さま担当部署
    this.registContractInfoForm.controls['houkatsuOkyakusamaTantoBusho']
      .setValue(incCtrInfoDto.inclusioncontractVisitTantobusho);
    // 包括お客さま担当者
    this.registContractInfoForm.controls['houkatsuOkyakusamaTantosha']
      .setValue(incCtrInfoDto.inclusioncontractVisitTntsh);
    // 包括お客さま電話番号
    this.registContractInfoForm.controls['houkatsuOkyakusamaTELNo']
      .setValue(incCtrInfoDto.inclusioncontractVisitTelno);
    // 契約開始日
    this.registContractInfoForm.controls['keiyakuKaishiYMD']
      .setValue(this.timeApiService.convertStringToDate(incCtrInfoDto.inclusioncontractStartdate));
    // 包括契約適用年数
    this.registContractInfoForm.controls['houkatsuTekiyouNensu']
      .setValue(incCtrInfoDto.inclusioncontractApplyNumberofyears);

    // 契約変更適用開始日
    // 遷移パラメータが 期中変更 かつ 登録申請状況コードが 1(申請中)の場合
    if (this.mode === 'midterm_change'
      && incCtrInfoDto.inclusioncontractRegistrationapplicationJokycd === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_APLY_CD.APPLY) {
      this.registContractInfoForm.controls['keiyakuHenkouTekiyouKaishiYMD']
        .setValue(this.timeApiService.convertStringToDate(incCtrInfoDto.inclusioncontractCtrchgEffectivestartdate));
      // 遷移パラメータが 承認 かつ 契約登録種別コードが期中契約変更（需給契約の追加・解除） かつ 登録申請状況コードが 1(申請中)の場合
    } else if (this.mode === 'approve'
      && incCtrInfoDto.inclusioncontractRegistrationapplicationClscode === SgkbConstains.CODE.HOUKATSU_CNTRCT_REGIST_CLY_CD.MID_CHANGE
      && incCtrInfoDto.inclusioncontractRegistrationapplicationJokycd === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_APLY_CD.APPLY) {
      this.registContractInfoForm.controls['keiyakuHenkouTekiyouKaishiYMD']
        .setValue(this.timeApiService.convertStringToDate(incCtrInfoDto.inclusioncontractCtrchgEffectivestartdate));
    } else {
      this.registContractInfoForm.controls['keiyakuHenkouTekiyouKaishiYMD']
        .setValue(null);
    }

    // 契約満了日
    this.registContractInfoForm.controls['keiyakuManryouYMD']
      .setValue(this.timeApiService.convertStringToDate(incCtrInfoDto.inclusioncontractExpirationdate));
    // 解約日
    this.registContractInfoForm.controls['kaiyakuYMD']
      .setValue(this.timeApiService.convertStringToDate(incCtrInfoDto.inclusioncontractTerminationdate));
    // 包括割引・割増方法
    this.registContractInfoForm.controls['houkatsuHouhouCategory']
      .setValue(incCtrInfoDto.discountextraSyurui);
    // メモ
    this.registContractInfoForm.controls['memo']
      .setValue(incCtrInfoDto.memo);

    // 包括契約履歴番号
    this.registContractInfoForm.controls['inclusioncontractRrkno']
      .setValue(incCtrInfoDto.inclusioncontractRrkno);
    // 包括契約年度内通番号
    this.registContractInfoForm.controls['inclusioncontractYearnaiSrno']
      .setValue(incCtrInfoDto.inclusioncontractYearnaiSrno);
    // 包括契約状態コード
    this.registContractInfoForm.controls['inclusioncontractStcode']
      .setValue(incCtrInfoDto.inclusioncontractStcode);
    // 登録申請状況コード
    this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationJokycd']
      .setValue(incCtrInfoDto.inclusioncontractRegistrationapplicationJokycd);
    // 解約申請状況コード
    this.registContractInfoForm.controls['inclusioncontractBreakereqestJokycd']
      .setValue(incCtrInfoDto.inclusioncontractBreakereqestJokycd);
    // 契約登録種別コード
    this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationClscode']
      .setValue(incCtrInfoDto.inclusioncontractRegistrationapplicationClscode);
    // 更新通番号
    this.registContractInfoForm.controls['updateSrno']
      .setValue(incCtrInfoDto.updateSrno);
    // 会社グループコード
    this.registContractInfoForm.controls['comgrpcd']
      .setValue(this.userOrganizationInfo.comgrpcd);
    // 遷移パラメータが 参照 の場合
    if (this.mode === 'read') {
      // 包括契約登録操作コード 1（照会）
      this.registContractInfoForm.controls['inclusioncontractRegOperationcode'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.INQUIRY);

      // 契約担当者リスト（非表示）
      this.keiyakuTantouflg = false;
      // 契約担当者テキスト
      this.registContractInfoForm.controls['keiyakuTantousha'].disable();
      // 解約日
      this.registContractInfoForm.controls['kaiyakuYMD'].disable();
      // メモ
      this.registContractInfoForm.controls['memo'].disable();
      // 参照、解約、承認、取消の共通項目設定
      this.setReadDisp();
    }
    // 遷移パラメータが 期中変更 の場合
    else if (this.mode === 'midterm_change') {
      // 包括契約登録操作コード 3（期中契約変更（需給契約の追加・解除））
      this.registContractInfoForm.controls['inclusioncontractRegOperationcode'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CHANGE);
      // 登録申請状況コード（申請中)
      this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationJokycd'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_APLY_CD.APPLY);
      // 契約登録種別コード（期中契約変更（需給契約の追加・解除）)
      this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationClscode'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_REGIST_CLY_CD.MID_CHANGE);

      // 包括お客さま番号（表示）
      this.houkatsuOkyakusamaNoDispFlg = true;
      // 登録、期中変更、契約更改の共通項目設定
      this.setRegistDisp();

      // 契約変更適用開始日
      this.keiyakuHenkouTekiyouKaishiYMD.setValidators(Validators.required);

      // 契約開始日 非活性
      this.registContractInfoForm.controls['keiyakuKaishiYMD'].disable();
      // 包括契約適用年数 非活性
      this.registContractInfoForm.controls['houkatsuTekiyouNensu'].disable();
      // 契約満了日 非活性
      this.registContractInfoForm.controls['keiyakuManryouYMD'].disable();
      // 割引・割増種類 非活性
      this.registContractInfoForm.controls['houkatsuHouhouCategory'].disable();
      // 登録、期中変更、契約更改の共通必須項目設定
      this.setRequired();
    }
    // 遷移パラメータが 契約更改 の場合
    else if (this.mode === 'renewal') {
      // 包括契約登録操作コード 4（契約更改）
      this.registContractInfoForm.controls['inclusioncontractRegOperationcode'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.RENEWAL);
      // 登録申請状況コード（申請中)
      this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationJokycd'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_APLY_CD.APPLY);
      // 契約登録種別コード（契約更改)
      this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationClscode'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_REGIST_CLY_CD.RENEWAL);

      // 包括お客さま番号（表示）
      this.houkatsuOkyakusamaNoDispFlg = true;
      // 契約変更適用開始日
      this.registContractInfoForm.controls['keiyakuHenkouTekiyouKaishiYMD'].disable();
      // 登録、期中変更、契約更改の共通項目設定
      this.setRegistDisp();

      // 契約開始日
      this.keiyakuKaishiYMD.setValidators(Validators.required);
      // 包括契約適用年数
      this.houkatsuTekiyouNensu.setValidators(Validators.required);
      // 契約満了日
      this.keiyakuManryouYMD.setValidators(Validators.required);
      // 割引・割増種類
      this.houkatsuHouhouCategory.setValidators(Validators.required);
      // 登録、期中変更、契約更改の共通必須項目設定
      this.setRequired();
    }
    // 遷移パラメータが 解約 の場合
    else if (this.mode === 'cancel') {
      // 包括契約登録操作コード 5（解約）
      this.registContractInfoForm.controls['inclusioncontractRegOperationcode'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CANCEL_CNTRCT);
      // 解約申請状況コード（申請中)
      this.registContractInfoForm.controls['inclusioncontractBreakereqestJokycd'].setValue(SgkbConstains.CODE.HOUKATSU_CANCEL_APLY_CD.APPLY);

      // 契約担当者リスト（非表示）
      this.keiyakuTantouflg = false;
      // 契約担当者テキスト
      this.registContractInfoForm.controls['keiyakuTantousha'].disable();
      // 参照、解約、承認、取消の共通項目設定
      this.setReadDisp();

      // 解約日
      this.kaiyakuYMD.setValidators(Validators.required);
    }
    // 遷移パラメータが 承認 の場合
    else if (this.mode === 'approve') {
      // 包括契約登録操作コード 6（承認）
      this.registContractInfoForm.controls['inclusioncontractRegOperationcode'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.APPROVAL);
      // 登録申請状況コード
      this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationJokycd'].setValue(
        this.setInclusioncontractRegistrationapplicationJokycd(incCtrInfoDto.inclusioncontractStcode, SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_APLY_CD.APPROVED));
      // 解約申請状況コード
      this.registContractInfoForm.controls['inclusioncontractBreakereqestJokycd'].setValue(
        this.setInclusioncontractBreakereqestJokycd(incCtrInfoDto.inclusioncontractBreakereqestJokycd, SgkbConstains.CODE.HOUKATSU_CANCEL_APLY_CD.APPLY));
      // 契約登録種別コード(包括契約検索結果.契約登録種別コード)
      this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationClscode'].setValue(incCtrInfoDto.inclusioncontractRegistrationapplicationClscode);

      // 契約担当者リスト（非表示）
      this.keiyakuTantouflg = false;
      // 契約担当者テキスト
      this.registContractInfoForm.controls['keiyakuTantousha'].disable();
      // 解約日
      this.registContractInfoForm.controls['kaiyakuYMD'].disable();
      // 参照、解約、承認、取消の共通項目設定
      this.setReadDisp();
    }
    // 遷移パラメータが 取消 の場合
    else if (this.mode === 'delete') {
      // 包括契約登録操作コード 9（取消）
      this.registContractInfoForm.controls['inclusioncontractRegOperationcode'].setValue(SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CANCEL);
      // 登録申請状況コード
      this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationJokycd'].setValue(
        this.setInclusioncontractRegistrationapplicationJokycd(incCtrInfoDto.inclusioncontractStcode, SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_APLY_CD.APPROVED));
      // 解約申請状況コード
      this.registContractInfoForm.controls['inclusioncontractBreakereqestJokycd'].setValue(
        this.setInclusioncontractBreakereqestJokycd(incCtrInfoDto.inclusioncontractBreakereqestJokycd, SgkbConstains.CODE.HOUKATSU_CANCEL_APLY_CD.APPLY));
      // 契約登録種別コード(包括契約検索結果.契約登録種別コード)
      this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationClscode'].setValue(incCtrInfoDto.inclusioncontractRegistrationapplicationClscode);

      // 契約担当者リスト（非表示）
      this.keiyakuTantouflg = false;
      // 契約担当者テキスト
      this.registContractInfoForm.controls['keiyakuTantousha'].disable();
      // 解約日
      this.registContractInfoForm.controls['kaiyakuYMD'].disable();
      // 参照、解約、承認、取消の共通項目設定
      this.setReadDisp();
    }
  }

  /**
   * 画面項目の初期化（値、活性状態）
   * @memberof Sgkb708dCtrinfoComponent
   */
  setInitDisp(): void {
    // 包括お客さま情報
    // 包括お客さま番号
    this.registContractInfoForm.controls['houkatsuOkyakusamaNo'].setValue("");
    this.registContractInfoForm.controls['houkatsuOkyakusamaNo'].disable();
    // 包括お客さま名
    this.registContractInfoForm.controls['houkatsuOkyakusamaName'].setValue("");
    this.registContractInfoForm.controls['houkatsuOkyakusamaName'].enable();
    // 郵便番号
    this.registContractInfoForm.controls['yubinNo'].setValue("");
    this.registContractInfoForm.controls['yubinNo'].enable();
    // 都道府県
    this.registContractInfoForm.controls['todoufuken'].setValue("");
    this.registContractInfoForm.controls['todoufuken'].enable();
    // 都道府県hidden
    this.registContractInfoForm.controls['todoufukenCategory'].setValue("");
    this.registContractInfoForm.controls['todoufukenCategory'].enable();
    // 行政市区
    this.registContractInfoForm.controls['gyouseishiku'].setValue("");
    this.registContractInfoForm.controls['gyouseishiku'].enable();
    // 行政市区hidden
    this.registContractInfoForm.controls['gyouseishikuCategory'].setValue("");
    this.registContractInfoForm.controls['gyouseishikuCategory'].enable();
    // 行政町名
    this.registContractInfoForm.controls['gyouseichomei'].setValue("");
    this.registContractInfoForm.controls['gyouseichomei'].enable();
    // 行政町名hidden
    this.registContractInfoForm.controls['gyouseichomeiCategory'].setValue("");
    this.registContractInfoForm.controls['gyouseichomeiCategory'].enable();
    // 丁目
    this.registContractInfoForm.controls['chomeCategory'].setValue("");
    this.registContractInfoForm.controls['chomeCategory'].enable();
    // 番地・号
    this.registContractInfoForm.controls['banchi'].setValue("");
    this.registContractInfoForm.controls['banchi'].enable();
    // 建物名
    this.registContractInfoForm.controls['tatemonoName'].setValue("");
    this.registContractInfoForm.controls['tatemonoName'].enable();
    // 部屋番号
    this.registContractInfoForm.controls['heyaNo'].setValue("");
    this.registContractInfoForm.controls['heyaNo'].enable();
    // 契約担当部署
    this.registContractInfoForm.controls['keiyakuTantouBushoCategory'].setValue("");
    this.registContractInfoForm.controls['keiyakuTantouBushoCategory'].enable();
    // 契約担当者リスト
    this.registContractInfoForm.controls['keiyakuTantoushaCategory'].setValue("");
    this.registContractInfoForm.controls['keiyakuTantoushaCategory'].enable();
    // 契約担当者テキスト
    this.registContractInfoForm.controls['keiyakuTantousha'].setValue("");
    this.registContractInfoForm.controls['keiyakuTantousha'].enable();
    // 包括お客さま担当部署
    this.registContractInfoForm.controls['houkatsuOkyakusamaTantoBusho'].setValue("");
    this.registContractInfoForm.controls['houkatsuOkyakusamaTantoBusho'].enable();
    // 包括お客さま担当者
    this.registContractInfoForm.controls['houkatsuOkyakusamaTantosha'].setValue("");
    this.registContractInfoForm.controls['houkatsuOkyakusamaTantosha'].enable();
    // 包括お客さま電話番号
    this.registContractInfoForm.controls['houkatsuOkyakusamaTELNo'].setValue("");
    this.registContractInfoForm.controls['houkatsuOkyakusamaTELNo'].enable();

    // 包括契約情報
    // 契約開始日
    this.registContractInfoForm.controls['keiyakuKaishiYMD'].setValue("");
    this.registContractInfoForm.controls['keiyakuKaishiYMD'].enable();
    // 包括契約適用年数
    this.registContractInfoForm.controls['houkatsuTekiyouNensu'].setValue("");
    this.registContractInfoForm.controls['houkatsuTekiyouNensu'].enable();
    // 契約変更適用開始日
    this.registContractInfoForm.controls['keiyakuHenkouTekiyouKaishiYMD'].setValue("");
    this.registContractInfoForm.controls['keiyakuHenkouTekiyouKaishiYMD'].enable();
    // 契約満了日
    this.registContractInfoForm.controls['keiyakuManryouYMD'].setValue("");
    this.registContractInfoForm.controls['keiyakuManryouYMD'].enable();
    // 解約日
    this.registContractInfoForm.controls['kaiyakuYMD'].setValue("");
    this.registContractInfoForm.controls['kaiyakuYMD'].enable();
    // 包括割引・割増方法
    this.registContractInfoForm.controls['houkatsuHouhouCategory'].setValue("");
    this.registContractInfoForm.controls['houkatsuHouhouCategory'].enable();
    // メモ
    this.registContractInfoForm.controls['memo'].setValue("");
    this.registContractInfoForm.controls['memo'].enable();
    // 包括契約履歴番号
    this.registContractInfoForm.controls['inclusioncontractRrkno'].setValue("");
    this.registContractInfoForm.controls['inclusioncontractRrkno'].enable();
    // 包括契約年度内通番号
    this.registContractInfoForm.controls['inclusioncontractYearnaiSrno'].setValue("");
    this.registContractInfoForm.controls['inclusioncontractYearnaiSrno'].enable();
    // 包括契約状態コード
    this.registContractInfoForm.controls['inclusioncontractStcode'].setValue("");
    this.registContractInfoForm.controls['inclusioncontractStcode'].enable();
    // 登録申請状況コード
    this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationJokycd'].setValue("");
    this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationJokycd'].enable();
    // 解約申請状況コード
    this.registContractInfoForm.controls['inclusioncontractBreakereqestJokycd'].setValue("");
    this.registContractInfoForm.controls['inclusioncontractBreakereqestJokycd'].enable();
    // 契約登録種別コード
    this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationClscode'].setValue("");
    this.registContractInfoForm.controls['inclusioncontractRegistrationapplicationClscode'].enable();
    // 包括契約登録操作コード
    this.registContractInfoForm.controls['inclusioncontractRegOperationcode'].setValue("");
    this.registContractInfoForm.controls['inclusioncontractRegOperationcode'].enable();
    // 更新通番号
    this.registContractInfoForm.controls['updateSrno'].setValue("");
    this.registContractInfoForm.controls['updateSrno'].enable();
    // 会社グループコード
    this.registContractInfoForm.controls['comgrpcd'].setValue("");
    this.registContractInfoForm.controls['comgrpcd'].enable();
  }

  /**
   * 参照、解約、承認、取消の共通項目設定
   * @memberof Sgkb708dCtrinfoComponent
   */
  setReadDisp(): void {
    // 包括お客さま番号（表示）
    this.houkatsuOkyakusamaNoDispFlg = true;
    this.registContractInfoForm.controls['houkatsuOkyakusamaNo'].disable();
    // 包括お客さま名
    this.registContractInfoForm.controls['houkatsuOkyakusamaName'].disable();
    // 郵便番号
    this.registContractInfoForm.controls['yubinNo'].disable();
    // 検索ボタン（非活性）
    this.zyuushoSearchDisabledFlg = true;
    // 丁目
    this.registContractInfoForm.controls['chomeCategory'].disable();
    // 番地・号
    this.registContractInfoForm.controls['banchi'].disable();
    // 建物名
    this.registContractInfoForm.controls['tatemonoName'].disable();
    // 部屋番号
    this.registContractInfoForm.controls['heyaNo'].disable();
    // 契約担当部署
    this.registContractInfoForm.controls['keiyakuTantouBushoCategory'].disable();
    // 包括お客さま担当部署
    this.registContractInfoForm.controls['houkatsuOkyakusamaTantoBusho'].disable();
    // 包括お客さま担当者
    this.registContractInfoForm.controls['houkatsuOkyakusamaTantosha'].disable();
    // 包括お客さま電話番号
    this.registContractInfoForm.controls['houkatsuOkyakusamaTELNo'].disable();
    // 契約開始日
    this.registContractInfoForm.controls['keiyakuKaishiYMD'].disable();
    // 包括契約適用年数
    this.registContractInfoForm.controls['houkatsuTekiyouNensu'].disable();
    // 契約変更適用開始日
    this.registContractInfoForm.controls['keiyakuHenkouTekiyouKaishiYMD'].disable();
    // 契約満了日
    this.registContractInfoForm.controls['keiyakuManryouYMD'].disable();
    // 割引・割増種類
    this.registContractInfoForm.controls['houkatsuHouhouCategory'].disable();
  }

  /**
   * 登録、期中変更、契約更改の共通項目設定
   * @memberof Sgkb708dCtrinfoComponent
   */
  setRegistDisp(): void {
    // 検索ボタン（活性）
    this.zyuushoSearchDisabledFlg = false;
    // 契約担当者リスト（表示）
    this.keiyakuTantouflg = true;
    // 解約日
    this.registContractInfoForm.controls['kaiyakuYMD'].disable();
  }

  /**
   * 登録、期中変更、契約更改の必須設定
   * @memberof Sgkb708dCtrinfoComponent
   */
  setRequired(): void {
    // 包括お客さま名
    this.houkatsuOkyakusamaName.setValidators(Validators.required);
    // 郵便番号
    this.yubinNo.setValidators(Validators.required);
    // 都道府県
    this.todoufuken.setValidators(Validators.required);
    // 行政市区
    this.gyouseishiku.setValidators(Validators.required);
    // 行政町名
    this.gyouseichomei.setValidators(Validators.required);
    // 丁目
    this.chomeCategory.setValidators(Validators.required);
  }

  /**
   * 定額、定率表示処理
   * @memberof Sgkb708dCtrinfoComponent
   */
  changedCategory(category: string): void {
    this.selectedType.emit(category);
  }

  /**
   * 検索ボタン（住所）押下時処理
   * @memberof Sgkb708dCtrinfoComponent
   */
  onClickZyuushoSearch(postno: string, addressCode: string): void {
    const aftPostno = postno.replace(/-/g, '');
    this.usedSzza001aService.searchZyuushoCode(aftPostno)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {

        let chomeList: SelectBox[] = [];
        if (response.addressSearchInfoToZipCodeDtoList != null) {
          const ZipDto = response.addressSearchInfoToZipCodeDtoList[0];
          // 都道府県
          this.registContractInfoForm.controls['todoufuken'].setValue(ZipDto.prefecturesName);
          this.registContractInfoForm.controls['todoufukenCategory'].setValue(ZipDto.addressCode.slice(0, 2));
          // 行政市区
          this.registContractInfoForm.controls['gyouseishiku'].setValue(ZipDto.cityName);
          this.registContractInfoForm.controls['gyouseishikuCategory'].setValue(ZipDto.addressCode.slice(2, 5));
          // 行政町名
          this.registContractInfoForm.controls['gyouseichomei'].setValue(ZipDto.townAreaName);
          this.registContractInfoForm.controls['gyouseichomeiCategory'].setValue(ZipDto.addressCode.slice(5, 8));

          for (let dto of response.addressSearchInfoToZipCodeDtoList) {
            let data: SelectBox = {
              value: dto.addressCode.slice(8, 11),
              viewValue: dto.ooazaName
            }
            chomeList.push(data);
          }
          // 丁目セレクトボックス
          this.chomeList = chomeList;
          if (addressCode != null) {
            this.registContractInfoForm.controls['chomeCategory'].setValue(addressCode.slice(8, 11));
          } else {
            this.registContractInfoForm.controls['chomeCategory'].setValue('');
          }
        }
      });
  }

  formatYubinNo(): void {
    setTimeout(() => {
      const control = this.registContractInfoForm.get('yubinNo');
      let value = control?.value?.replace(/[^0-9]/g, '') || '';
      if (value.length > 3) {
        const formatted = `${value.slice(0, 3)}-${value.slice(3, 7)}`;
        if (control?.value !== formatted) {
          control?.setValue(formatted, { emitEvent: false });
        }
      }
    }, 0); // IMEの処理が終わるまで待つ
  }

  /**
   * 契約担当者リスト表示処理
   * @memberof Sgkb701dSearchConditionComponent
   */
  onChangeSelectBox(event: any): void {
    // 社員情報取得レスポンスを取得
    this.bushoCode = event.value
    this.usedSgkb992aService.searchContractor(this.setSgkb992aRequest())
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb992aResponseCommon = response.responseCommon;
        this.staffInfoList = response.staffInfoList;
        /** 契約担当者リスト情報 */
        this.staffInfoList.forEach(data => {
          this.keiyakuTantoushaList = this.staffInfoList.map(data =>
          ({
            value: data.staffCode,
            viewValue: data.staffName
          }));
        });
      })

    // 検索後は何も選択されていない状態にする
    this.registContractInfoForm.controls['keiyakuTantoushaCategory'].setValue(null);
  }

  /**
   * 契約担当者リスト表示処理
   * @memberof Sgkb701dSearchConditionComponent
   */
  onChangeTantousha(event: any): void {
    const selectedValue = event.value;
    const selectedItem = this.keiyakuTantoushaList.find(
      data => data.value === selectedValue
    );
    const viewValue = selectedItem?.viewValue;
    this.registContractInfoForm.controls['keiyakuTantousha']
      .setValue(viewValue);
  }


  /**
  * 部署情報検索のリクエスト設定
  * @memberof Sgkb701dSearchConditionComponent
  */
  setSgkb991aRequest(): Sgkb991aRequest {
    // 部署情報検索リクエストを作成
    const sgkb991aRequest: Sgkb991aRequest = {
      companyInfo: {
        // 会社グループコード
        companyGroupCode: this.userOrganizationInfo.comgrpcd,
        // 会社コード
        companyCode: this.userOrganizationInfo.comCode
      }
    }
    return sgkb991aRequest;
  }

  /**
   * 社員情報検索のリクエスト設定
   * @memberof Sgkb701dSearchConditionComponent
   */
  setSgkb992aRequest(): Sgkb992aRequest {
    // 社員情報検索リクエストを作成
    const sgkb992aRequest: Sgkb992aRequest = {
      bushoInfo: {
        // 部署コード
        bushoCode: this.bushoCode,
      }
    }
    return sgkb992aRequest;
  }

  /**
   * 登録申請状況コード設定
   * @memberof Sgkb701dSearchConditionComponent
   */
  setInclusioncontractRegistrationapplicationJokycd(inclusioncontractRegOperationcode: string, inclusioncontractRegistrationapplicationJokycd: string): string {
    // DBに登録されている包括契約登録操作コードが解約の場合
    // 登録申請状況コードは設定しない
    if (inclusioncontractRegOperationcode === SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_OPE_CD.CANCEL_CNTRCT) {
      return null;
      // DBに登録されている包括契約登録操作コードが解約以外の場合
    } else {
      return inclusioncontractRegistrationapplicationJokycd;
    }
  }

  /**
   * 解約申請状況コード設定
   * @memberof Sgkb701dSearchConditionComponent
   */
  setInclusioncontractBreakereqestJokycd(val: string, inclusioncontractBreakereqestJokycd: string): string {
    // DBに登録されている解約申請状況コードが申請中の場合
    // 解約申請状況コード設定する
    if (val === SgkbConstains.CODE.HOUKATSU_CANCEL_APLY_CD.APPLY) {
      return inclusioncontractBreakereqestJokycd;
    } else {
      return null;
    }
  }
}
